module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/sales-leader-calendar/sales-leader-calendar.png"